import { render } from "./Previewfatture.vue?vue&type=template&id=b977e566&scoped=true"
import script from "./Previewfatture.vue?vue&type=script&lang=js"
export * from "./Previewfatture.vue?vue&type=script&lang=js"

import "./Previewfatture.vue?vue&type=style&index=0&id=b977e566&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b977e566"]])

export default __exports__